import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastService } from '@services/toast.service';
import { ConfigService } from '@services/config.service';
import { APP_ROUTES } from '@routes/app-routes.constants';
import { BYPASS_403_REDIRECT } from './http-context-tokens';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(ConfigService);
  const router = inject(Router);
  const toastService = inject(ToastService);

  if (!req.url.startsWith(config.apiEndpoint)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401) {
          router.navigate([APP_ROUTES.login]);
        } else if (error.status === 403) {
          if (req.context.get(BYPASS_403_REDIRECT)) {
            return throwError(() => error);
          }
          router.navigate([APP_ROUTES.accessDenied]);
          return EMPTY;
        } else if (error.status >= 500) {
          toastService.showToast('Erro interno do servidor. Tente novamente em instantes.');
          return EMPTY;
        }
      }
      return throwError(() => error);
    })
  );
};
